import { useParams } from '@tanstack/react-router';
import React from 'react';
import { z } from 'zod';

import { ArtistAbout } from '@/pages/artist/onboard/components/stages/about';
import { ArtistLanguages } from '@/pages/artist/onboard/components/stages/languages';
import { ArtistParameters } from '@/pages/artist/onboard/components/stages/parameters';
import { ArtistPhoto } from '@/pages/artist/onboard/components/stages/photo';
import { ArtistOnBoardVideo } from '@/pages/artist/onboard/components/stages/video';
import { ArtistWorkHistory } from '@/pages/artist/onboard/components/stages/work';

export const artistOnBoardingStages = z.enum([
  'work',
  'languages',
  'parameters',
  'photo',
  'video',
  'about'
]);

type Stages = z.infer<typeof artistOnBoardingStages>;

const component: Record<Stages, React.ReactNode> = {
  work: <ArtistWorkHistory />,
  languages: <ArtistLanguages />,
  parameters: <ArtistParameters />,
  photo: <ArtistPhoto />,
  video: <ArtistOnBoardVideo />,
  about: <ArtistAbout />
};

export const ArtistOnboarding = () => {
  const { step } = useParams({ from: '/artist/$id/_onboard/onboard/$step' });

  return <div>{component[step]}</div>;
};
